'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var charList = require('../character-list/character-list.json');
var faIconChars = charList.icons;

exports.default = faIconChars;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome-icon-chars/dist/index.js
// module id = dRyV
// module chunks = 1 7